module.exports = __webpack_public_path__ + "img/zz2.b706144b.png";